import { render, staticRenderFns } from "./ai-assistant-widget.vue?vue&type=template&id=5be0051d&scoped=true"
import script from "./ai-assistant-widget.vue?vue&type=script&lang=js"
export * from "./ai-assistant-widget.vue?vue&type=script&lang=js"
import style0 from "./ai-assistant-widget.vue?vue&type=style&index=0&id=5be0051d&scoped=true&lang=css"
import style1 from "./ai-assistant-widget.vue?vue&type=style&index=1&id=5be0051d&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0051d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be0051d')) {
      api.createRecord('5be0051d', component.options)
    } else {
      api.reload('5be0051d', component.options)
    }
    module.hot.accept("./ai-assistant-widget.vue?vue&type=template&id=5be0051d&scoped=true", function () {
      api.rerender('5be0051d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ai-assistant-widget.vue"
export default component.exports